var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import HeaderItem from "../accountcheck/components/HeaderItem.vue";
import EQuotedPriceType from '../../enum/EQuotedPriceType';
import GLOBAL_VUE from '../../globalVue';
import Add from './Add.vue';
import QuotedPrice from '../../api/QuotedPrice';
import { auth } from "../../helper/authDecorator";
import { nameDict } from "../../constant/authCode";
import { Loading } from 'element-ui';
import SearchGoods from './components/SearchGoods';
import UploadDialog from "./components/UploadDialog.vue";
var Detail = (function (_super) {
    __extends(Detail, _super);
    function Detail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.detail = { data: [] };
        _this.total = 0;
        _this.searchParams = {
            goods_type_id: undefined,
            keyword: '',
        };
        _this.fileListData = [];
        _this.is_show_quotation_current_price = 1;
        _this.enumType = EQuotedPriceType;
        _this.uploadDialogVisible = false;
        _this.isUpload = false;
        return _this;
    }
    Detail.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
    };
    Detail.prototype.mounted = function () {
        this.getDetail();
    };
    Detail.prototype.pageChange = function (pager) {
        this.getDetail();
    };
    Detail.prototype.getDetail = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        var params = {
            order_id: this.rowId,
            goods_type_id: this.searchParams.goods_type_id,
            keyword: this.searchParams.keyword,
        };
        Object.assign(params, { start: pager.start, limit: pager.limit });
        this.service.getDetail(params).then(function (res) {
            if (res.data.success) {
                var detail = res.data.data;
                _this.fileListData = detail.enclosures;
                _this.is_show_quotation_current_price = detail.is_show_quotation_current_price;
                if (params.keywords && JSON.stringify(detail) === '[]') {
                    _this.detail.order_detail = [];
                    _this.total = 0;
                }
                else {
                    _this.tableHeight = document.documentElement.clientHeight - 380 - 80
                        - (detail.order_type == '2' ? 0 : 44) + (detail.order_status == 0 ? 0 : 40);
                    _this.detail = detail;
                    _this.total = res.data.total || 0;
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        });
    };
    Detail.prototype.save = function () {
        var _this = this;
        var nextActionToCancelFlag = 1;
        var nextActionToSureFlag = 2;
        this.$confirm("提交后不可修改，请确认是否继续。").then(function () {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.submit(_this.rowId).then(function (res) {
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                    _this.getDetail();
                }
                else {
                    _this.$message.success(res.data.msg);
                    setTimeout(function () {
                        GLOBAL_VUE.$emit("closeTab", _this);
                        if (_this.opener) {
                            _this.opener.getList();
                        }
                    }, 1000);
                }
            }).catch(function (err) {
                loadingInstance.close();
                if (err.resData && err.resData.flag === nextActionToCancelFlag) {
                    _this.$confirm(err.resData.msg).then(function (res) {
                        _this.service.cancelByBusiness(err.resData.data).then(function (res) {
                            _this.$message.success(res.data.msg);
                            GLOBAL_VUE.$emit("closeTab", _this);
                            if (_this.opener) {
                                _this.opener.getList();
                            }
                        }).catch(function (err) {
                            _this.$message.error(err.msg || err.message);
                        });
                    });
                }
                else if (err.resData && err.resData.flag === nextActionToSureFlag) {
                    _this.$confirm('报价单存在报价为空的货品，请确认是否继续？', '提示', {
                        customClass: 'confirm'
                    }).then(function (res) {
                        if (res) {
                            var loadingInstance_1 = Loading.service({ fullscreen: true });
                            _this.service.submit(_this.rowId, 0).then(function (res) {
                                if (res.data.code == 76) {
                                    _this.$message.error(res.data.msg);
                                    _this.getDetail();
                                }
                                else {
                                    _this.$message.success(res.data.msg);
                                    setTimeout(function () {
                                        GLOBAL_VUE.$emit("closeTab", _this);
                                        if (_this.opener) {
                                            _this.opener.getList();
                                        }
                                    }, 1000);
                                }
                            }).catch(function (err) {
                                _this.$message.error(err.msg || err.message);
                                loadingInstance_1.close();
                            });
                        }
                    }).catch(function (err) {
                    });
                }
                else if (err.msg || err.message) {
                    loadingInstance.close();
                    _this.$message.error(err.msg || err.message);
                }
                else {
                    loadingInstance.close();
                }
            });
        }, function (err) { });
    };
    Detail.prototype.toEdit = function () {
        GLOBAL_VUE.$emit("closeTab", this);
        GLOBAL_VUE.$emit("addTab", {
            component: Add,
            title: '编辑常规报价',
            showExist: true,
            name: 'edit-view-' + this.rowId,
            cprops: {
                orderid: this.rowId,
                priceType: this.detail.order_type
            }
        });
    };
    Detail.prototype.search = function (searchParams) {
        this.searchParams = searchParams;
        this.$refs.pagination.clear();
        this.getDetail();
        window._czc.push(["_trackEvent", '报价详情', '货品搜索', '货品搜索']);
    };
    Detail.prototype.openUploadDialog = function () {
        this.uploadDialogVisible = !this.uploadDialogVisible;
    };
    Detail = __decorate([
        auth(nameDict["报价"]),
        Component({
            components: {
                UploadDialog: UploadDialog,
                HeaderItem: HeaderItem,
                SearchGoods: SearchGoods
            }
        })
    ], Detail);
    return Detail;
}(Vue));
export default Detail;
